<form id="busy-form" action="#" method="POST" soho-busyindicator [transparentOverlay]="transparentOverlay"
  [blockUI]="true" [text]="message" [displayDelay]="delay" autocomplete="off">
  <div id="notification">
  </div>
  <div class="row" style="padding-top:2%; padding-left:2%;">
    <h2 class="fieldset-title" style="font-size: x-large;">{{ProjectTitle}}</h2>
  </div>
  <div class="row">
    <div class="twelve columns">
      <div class="row">
        <div class="six columns" style="padding-left: 4%;padding-top: 3%;">
          <div class="field" id="divemployeeid">
            <label id="lblemployeeid" class="required" for="employeeid" [title]="CategoryToolTip">Employee ID:</label>
            <input type="text" id="employeeid" name="employeeid" (click)="RemoveError('employeeid')"
              [(ngModel)]="model.employeeid" [disabled]="true">
          </div>
          <div class="field" id="divmanagerid">
            <label id="lblmanagerid" class="required" for="managerid" [title]="CategoryToolTip">Manager ID:</label>
            <input type="text" id="managerid" name="managerid" (click)="RemoveError('managerid')"
              [(ngModel)]="model.managerid" [disabled]="true">
          </div>
          <div class="field" id="divlob">
            <label id="lbllob" class="required" for="lob" [title]="CategoryToolTip">LOB/Sales Unit:</label>
            <input type="text" id="lob" name="lob" (click)="RemoveError('lob')" [(ngModel)]="model.salesunit"
              [disabled]="true" />
          </div>
          <div class="field" id="divperpetualmultiplier">
            <label id="lblperpetualmultiplier" for="perpetualmultiplier" [title]="ApproverIDToolTip">Perpetual Multiplier:</label>
            <input id="perpetualmultiplier" name="perpetualmultiplier" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.perpetualmultiplier" [disabled]="true"
              />
          </div>
          <div class="field" id="divsaasmultipliergt1lt2years">
            <label id="lblsaasmultipliergt1lt2years" for="saasmultipliergt1lt2years" [title]="ApproverIDToolTip">SaaS Greater 1 and less than 2 Year Multiplier:</label>
            <input id="saasmultipliergt1lt2years" name="saasmultipliergt1lt2years" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.saasmultipliergt1lt2years" [disabled]="true"
              />
          </div>
          <!-- <div class="field" id="divsaaslogomultiplier">
            <label id="lblsaaslogomultiplier" for="saaslogomultiplier" [title]="ApproverIDToolTip">SaaS Logo Multiplier:</label>
            <input id="saaslogomultiplier" name="saaslogomultiplier" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.saaslogomultiplier"
              />
          </div> -->
          
        
          <div class="field" id="divplantype">
            <label id="lblplantype" class="required" for="plantype" [title]="CategoryToolTip">Plan Type:</label>
            <input type="text" id="plantype" name="plantype" (click)="RemoveError('plantype')"
              [(ngModel)]="model.plantype" [disabled]="true"/>
          </div>
          <div class="field" id="divperpetualquota">
            <label id="lblperpetualquota" for="perpetualquota" [title]="ApproverIDToolTip">Perpetual Quota:</label>
            <input id="perpetualquota" name="perpetualquota" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.perpetualquota"/>
          </div>

          <div class="field" id="divsaasgt3yearquota">
            <label id="lblsaasgt3yearquota" for="saasgt3yearquota" [title]="ApproverIDToolTip">SaaS greater than 3 Years Quota:</label>
            <input id="saasgt3yearquota" name="saasgt3yearquota" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.saasgt3yearquota" />
          </div>
          <div class="field" id="divterritorygroup">
            <label id="lblterritorygroup" class="required" for="territorygroup" [title]="CategoryToolTip">Territory:</label>
            <input type="text" id="territorygroup" name="territorygroup" (click)="RemoveError('territorygroup')" [(ngModel)]="model.territorygroup"
               />
          </div>
          <div class="field" id="divholdrecord">
            <label id="lblholdrecord" for="holdrecord" [title]="CategoryToolTip">Hold Record ?:</label>
               <select soho-dropdown id="holdrecord" name="holdrecord" [(ngModel)]="model.holdrecord">
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
          </div>

          <div class="field" id="divElement1">
            <label id="lblElement1"  for="element1" [title]="CategoryToolTip">Element1:</label>
            <input [disabled]="true"  type="text" id="element1" name="element1" (click)="RemoveError('element1')" [(ngModel)]="model.element1"     />
          </div>

          <div class="field" id="divpaycurve1" *ngIf="showPayCurves">
            <label id="lblpaycurve1"  for="paycurve1" [title]="CategoryToolTip">Pay Curve 1:</label>
            <input [disabled]="true"  type="text" id="paycurve1" name="paycurve1" (click)="RemoveError('paycurve1')" [(ngModel)]="model.paycurve1"     />
          </div>
          
          <div class="field" id="divElement2">
            <label id="lblElement2"  for="element2" [title]="CategoryToolTip">Element2:</label>
            <input [disabled]="true"  type="text" id="element2" name="element2" (click)="RemoveError('element2')" [(ngModel)]="model.element2"     />
          </div>

          <div class="field" id="divpaycurve2" *ngIf="showPayCurves">
            <label id="lblpaycurve2"  for="paycurve2" [title]="CategoryToolTip">Pay Curve 2:</label>
            <input [disabled]="true"  type="text" id="paycurve2" name="paycurve2" (click)="RemoveError('paycurve2')" [(ngModel)]="model.paycurve2"     />
          </div>
          
          <div class="field" id="divElement3">
            <label id="lblElement3"  for="element3" [title]="CategoryToolTip">Element3:</label>
            <input [disabled]="true"  type="text" id="element3" name="element3" (click)="RemoveError('element3')" [(ngModel)]="model.element3"     />
          </div>

          <div class="field" id="divpaycurve3" *ngIf="showPayCurves">
            <label id="lblpaycurve3"  for="paycurve3" [title]="CategoryToolTip">Pay Curve 3:</label>
            <input [disabled]="true"  type="text" id="paycurve3" name="paycurve3" (click)="RemoveError('paycurve3')" [(ngModel)]="model.paycurve3"     />
          </div>
          
          <div class="field" id="divElement4">
            <label id="lblElement4"  for="element4" [title]="CategoryToolTip">Element4:</label>
            <input [disabled]="true"  type="text" id="element4" name="element4" (click)="RemoveError('element4')" [(ngModel)]="model.element4"     />
          </div>

          <div class="field" id="divpaycurve4" *ngIf="showPayCurves">
            <label id="lblpaycurve4"  for="paycurve4" [title]="CategoryToolTip">Pay Curve 4:</label>
            <input [disabled]="true"  type="text" id="paycurve4" name="paycurve4" (click)="RemoveError('paycurve4')" [(ngModel)]="model.paycurve4"     />
          </div>
          
          <div class="field" id="divElement5">
            <label id="lblElement5"   for="element5" [title]="CategoryToolTip">Element5:</label>
            <input [disabled]="true"  type="text" id="element5" name="element5" (click)="RemoveError('element5')" [(ngModel)]="model.element5"     />
          </div>

          <div class="field" id="divpaycurve5" *ngIf="showPayCurves">
            <label id="lblpaycurve5"  for="paycurve5" [title]="CategoryToolTip">Pay Curve 5:</label>
            <input [disabled]="true"  type="text" id="paycurve5" name="paycurve5" (click)="RemoveError('paycurve5')" [(ngModel)]="model.paycurve5"     />
          </div>
          <div class="field" id="divq1_1">
            <label id="lblq1_1"  for="q1_1" [title]="CategoryToolTip">Element1 q1:</label>
            <input type="text" id="q1_1" name="q1_1" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q1_1')" [(ngModel)]="model.q1_1"     />
          </div>
          <div class="field" id="divq3_1">
            <label id="lblq3_1"  for="q3_1" [title]="CategoryToolTip">Element1 q3:</label>
            <input type="text" id="q3_1" name="q3_1" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q3_1')" [(ngModel)]="model.q3_1"     />
          </div>
          <div class="field" id="divq1_2">
            <label id="lblq1_2"  for="q1_2" [title]="CategoryToolTip">Element2 q1:</label>
            <input type="text" id="q1_2" name="q1_2" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q1_2')" [(ngModel)]="model.q1_2"     />
          </div>
          <div class="field" id="divq3_2">
            <label id="lblq3_2"  for="q3_2" [title]="CategoryToolTip">Element2 q3:</label>
            <input type="text" id="q3_2" name="q3_2" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q3_2')" [(ngModel)]="model.q3_2"     />
          </div>
          <div class="field" id="divq1_3">
            <label id="lblq1_3"  for="q1_3" [title]="CategoryToolTip">Element3 q1:</label>
            <input type="text" id="q1_3" name="q1_3" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q1_3')" [(ngModel)]="model.q1_3"     />
          </div>
          <div class="field" id="divq3_3">
            <label id="lblq3_3"  for="q3_3" [title]="CategoryToolTip">Element3 q3:</label>
            <input type="text" id="q3_3" name="q3_3" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q3_3')" [(ngModel)]="model.q3_3"     />
          </div>
          <div class="field" id="divq1_4">
            <label id="lblq1_4"  for="q1_4" [title]="CategoryToolTip">Element4 q1:</label>
            <input type="text" id="q1_4" name="q1_4" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q1_4')" [(ngModel)]="model.q1_4"     />
          </div>
          <div class="field" id="divq3_4">
            <label id="lblq3_4"  for="q3_4" [title]="CategoryToolTip">Element4 q3:</label>
            <input type="text" id="q3_4" name="q3_4" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q3_4')" [(ngModel)]="model.q3_4"     />
          </div>
          <div class="field" id="divq1_5">
            <label id="lblq1_5"  for="q1_5" [title]="CategoryToolTip">Element5 q1:</label>
            <input type="text" id="q1_5" name="q1_5" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q1_5')" [(ngModel)]="model.q1_5"     />
          </div>
          <div class="field" id="divq3_5">
            <label id="lblq3_5"  for="q3_5" [title]="CategoryToolTip">Element5 q3:</label>
            <input type="text" id="q3_5" name="q3_5" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q3_5')" [(ngModel)]="model.q3_5"     />
          </div>
        </div>
        <div class="six columns" style="padding-left: 2%;padding-top: 2%;">
          <div class="field" id="divemployeefirstname">
            <label id="lblemployeefirstname" class="required" for="employeefirstname" [title]="CategoryToolTip">Employee Name:</label>
            <input type="text" id="employeefirstname" name="employeefirstname" (click)="RemoveError('employeefirstname')"
              [(ngModel)]="model.employeefirstname" [disabled]="true" />
          </div>
          <div class="field" id="divmanagername">
            <label id="lblmanagername" class="required" for="managername" [title]="CategoryToolTip">Manager Name:</label>
            <input type="text" id="managername" name="managername" (click)="RemoveError('managername')"
              [(ngModel)]="model.managername" [disabled]="true" />
          </div>
          <div class="field" id="divreprole">
            <label id="lblreprole" class="required" for="reprole" [title]="CategoryToolTip">Rep role:</label>
            <input type="text" id="reprole" name="reprole" (click)="RemoveError('reprole')" [(ngModel)]="model.reprole"
              [disabled]="true" />
          </div>
          <div class="field" id="divsaasmultiplierlt3years">
            <label id="lblsaasmultiplierlt3years" for="saasmultipliergt2lt3years" [title]="ApproverIDToolTip">SaaS Less than 1 year Multiplier:</label>
            <input id="saasmultipliergt2lt3years" name="saasmultipliergt2lt3years" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.saasmultipliergt2lt3years" [disabled]="true"
              />
          </div>
          <!-- <div class="field" id="divperpetuallogomultiplier">
            <label id="lblperpetuallogomultiplier" for="perpetuallogomultiplier" [title]="ApproverIDToolTip">MES Multiplier:</label>
            <input id="perpetuallogomultiplier" name="perpetuallogomultiplier" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.perpetuallogomultiplier"
              (click)="RemoveError('perpetuallogomultiplier')" />
          </div> -->
          <div class="field" id="divsaasmultipliergt3years">
            <label id="lblsaasmultipliergt3years" for="saasmultipliergt3years" [title]="ApproverIDToolTip">SaaS greater than 2 Year Multiplier:</label>
            <input id="saasmultipliergt3years" name="saasmultipliergt3years" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.saasmultipliergt3years"
              (click)="RemoveError('saasmultipliergt3years')" [disabled]="true" />
          </div>
          <div class="field" id="divvariablepay">
            <label id="lblvariablepay" class="required" for="variablepay" [title]="ApproverIDToolTip">Variable
              Pay:</label>
            <input id="variablepay" name="variablepay" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.variablepay"
              (click)="RemoveError('variablepay')" [disabled]="true" />
          </div>
          <!-- <div class="field" id="divnclbmultiplier">
            <label id="lblnclbmultiplier" for="nclbmultiplier" [title]="ApproverIDToolTip">NCLB Multiplier:</label>
            <input id="nclbmultiplier" name="nclbmultiplier" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.nclbmultiplier"
              (click)="RemoveError('nclbmultiplier')" />
          </div> -->
          <div class="field" id="divvariablepaycurrency">
            <label id="lblvariablepaycurrency" class="required" for="variablepaycurrency"
              [title]="ApproverIDToolTip">Variablepay Currency:</label>
            <input type="text" id="variablepaycurrency" name="variablepaycurrency"
              (click)="RemoveError('variablepaycurrency')" [(ngModel)]="model.variablepaycurrency" [disabled]="true" maxlength="3"/>
          </div>
          <div class="field" id="divfiscalyear">
            <label id="lblfiscalyear" class="required" for="fiscalyear" [title]="ApproverIDToolTip">Fiscalyear:</label>
            <input id="fiscalyear" (click)="RemoveError('fiscalyear')" name="fiscalyear" type="text"
              [(ngModel)]="model.fiscalyear" [disabled]="true" />
          </div>
          <div class="field" id="divsaaslt3yearquota">
            <label id="lblsaaslt3yearquota" for="saaslt3yearquota" [title]="ApproverIDToolTip">SaaS less than 3 Years Quota:</label>
            <input id="saaslt3yearquota" name="saaslt3yearquota" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' [(ngModel)]="model.saaslt3yearquota" />
          </div>
          
          <div class="field" id="divplanstartdate">
            <label for="planstartdate" class="required" class="label">Plan Start Date</label>
            <input soho-datepicker id="planstartdate" name="planstartdate" dateFormat="MM/dd/yyyy" mode="standard"
              placeholder="MM/dd/yyyy" [(ngModel)]="model.planstartdate"/>
          </div>
          <div class="field" id="divtotalquota">
            <label id="lbltotalquota" class="required" for="totalquota" [title]="ApproverIDToolTip">Total Quota:</label>
            <input id="totalquota" name="totalquota" type="number" inputmode="numeric" placeholder="0.00" data-mask
              data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('totalquota')" [(ngModel)]="model.totalquota"/>
          </div>
          <div class="field" id="divtotalquota2">
            <label id="lbltotalquota2"  for="totalquota2" [title]="CategoryToolTip">Total quota 2:</label>
            <input type="text" id="totalquota2" name="totalquota2" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('totalquota2')" [(ngModel)]="model.totalquota2"     />
          </div>
          <div class="field" id="divtotalquota3">
            <label id="lbltotalquota3"   for="totalquota3" [title]="CategoryToolTip">Total quota 3:</label>
            <input type="text" id="totalquota3" name="totalquota3" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('totalquota3')" [(ngModel)]="model.totalquota3"     />
          </div>
          <div class="field" id="divtotalquota4">
            <label id="lbltotalquota4"  for="totalquota4" [title]="CategoryToolTip">Total quota 4:</label>
            <input type="text" id="totalquota4" name="totalquota4" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('totalquota4')" [(ngModel)]="model.totalquota4"     />
          </div>
          <div class="field" id="divtotalquota5">
            <label id="lbltotalquota5"  for="totalquota5" [title]="CategoryToolTip">Total quota 5:</label>
            <input type="text" id="totalquota5" name="totalquota5" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('totalquota5')" [(ngModel)]="model.totalquota5"     />
          </div>
          <div class="field" id="divq2_1">
            <label id="lblq2_1"  for="q2_1" [title]="CategoryToolTip">Element1 q2:</label>
            <input type="text" id="q2_1" name="q2_1" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q2_1')" [(ngModel)]="model.q2_1"     />
          </div>
          <div class="field" id="divq4_1">
            <label id="lblq4_1"  for="q4_1" [title]="CategoryToolTip">Element1 q4:</label>
            <input type="text" id="q4_1" name="q4_1" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q4_1')" [(ngModel)]="model.q4_1"     />
          </div>
          <div class="field" id="divq2_2">
            <label id="lblq2_2"  for="q2_2" [title]="CategoryToolTip">Element2 q2:</label>
            <input type="text" id="q2_2" name="q2_2" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q2_2')" [(ngModel)]="model.q2_2"     />
          </div>
          <div class="field" id="divq4_2">
            <label id="lblq4_2"  for="q4_2" [title]="CategoryToolTip">Element2 q4:</label>
            <input type="text" id="q4_2" name="q4_2" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q4_2')" [(ngModel)]="model.q4_2"     />
          </div>
          <div class="field" id="divq2_3">
            <label id="lblq2_3"  for="q2_3" [title]="CategoryToolTip">Element3 q2:</label>
            <input type="text" id="q2_3" name="q2_3" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q2_3')" [(ngModel)]="model.q2_3"     />
          </div>
          <div class="field" id="divq4_3">
            <label id="lblq4_3"  for="q4_3" [title]="CategoryToolTip">Element3 q4:</label>
            <input type="text" id="q4_3" name="q4_3" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q4_3')" [(ngModel)]="model.q4_3"     />
          </div>
          <div class="field" id="divq2_4">
            <label id="lblq2_4"  for="q2_4" [title]="CategoryToolTip">Element4 q2:</label>
            <input type="text" id="q2_4" name="q2_4" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q2_4')" [(ngModel)]="model.q2_4"     />
          </div>
          <div class="field" id="divq4_4">
            <label id="lblq4_4"  for="q4_4" [title]="CategoryToolTip">Element4 q4:</label>
            <input type="text" id="q4_4" name="q4_4" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q4_4')" [(ngModel)]="model.q4_4"     />
          </div>
          <div class="field" id="divq2_5">
            <label id="lblq2_5"  for="q2_5" [title]="CategoryToolTip">Element5 q2:</label>
            <input type="text" id="q2_5" name="q2_5" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q2_5')" [(ngModel)]="model.q2_5"     />
          </div>
          <div class="field" id="divq4_5">
            <label id="lblq4_5"  for="q4_5" [title]="CategoryToolTip">Element5 q4:</label>
            <input type="text" id="q4_5" name="q4_5" type="number" inputmode="numeric" placeholder="0.00" data-mask
            data-options='{ "pattern" : "###.##", "mode": "number" }' (click)="RemoveError('q4_5')" [(ngModel)]="model.q4_5"     />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">

  </div>
  <div class="row" id="divUpdate" style="text-align: center;padding-top: 2%;">
    <button class="btn-primary hide-focus" type="button" (click)="UpdateDetailedQuotas()">Update</button>&nbsp;
    <button class="btn-secondary hide-focus" type="button" (click)="Cancel()">Cancel</button>
    <input type="button" id="btnBusy" (click)="LoadBusyIndicator()" style="display: none;">
  </div>
</form>